export const StatCard = ({ icon: Icon, label, value, hint, tone = "default" }) => (
  <div data-testid={`stat-card-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="card-ae p-5 flex items-start gap-4">
    <div className={`rounded-lg p-2.5 ${tone === "alert" ? "bg-red-50 text-red-600" : tone === "gold" ? "bg-gold-light text-gold" : "bg-sage-light text-deepgreen"}`}>
      {Icon && <Icon className="h-5 w-5" aria-hidden />}
    </div>
    <div>
      <p className="text-2xl font-heading font-semibold text-deepgreen leading-none">{value}</p>
      <p className="mt-1.5 text-xs font-semibold uppercase tracking-[0.1em] text-muted-foreground">{label}</p>
      {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
    </div>
  </div>
);
